import React from 'react';
import { Link } from 'react-router-dom';
import './StateLocals.css';

const compare = (a, b) => String(a ?? '').trim().localeCompare(String(b ?? '').trim(), 'en', { numeric: true, sensitivity: 'base' });

export function sortStateLocals(locals) {
  return [...locals].sort((a, b) => {
    const aBlank = !String(a.LOCAL ?? '').trim();
    const bBlank = !String(b.LOCAL ?? '').trim();
    return Number(aBlank) - Number(bBlank) || compare(a.LOCAL, b.LOCAL) ||
      compare(a.NAME, b.NAME) || compare(a.UNIT, b.UNIT) || compare(a.id, b.id);
  });
}

export default function StateLocals({ locals }) {
  return (
    <ul className="state-locals-list" aria-label="State locals, ordered by local number">
      {sortStateLocals(locals).map(local => (
        <li key={local.id}>
          <Link to={`/units/${local.id}`} state={{ fromLetter: 'State' }}>
            <span className="state-local-number">Local {local.LOCAL}</span>
            <span className="state-local-name">{local.NAME}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
